import moment from 'moment';

function asDate(dateTime) {
  return moment.parseZone(dateTime).format('DD MMM YY [at] HH:mm');
}

export { asDate };
